import { SSRPrepareErrorsClient } from '../src/SSRPrepareErrorsClient.ts';

export const ssrPrepareErrorsClient = new SSRPrepareErrorsClient();
